/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SendEmailOtpRequest = {
  properties: {
    type: {
      type: 'Enum',
      isRequired: true,
    },
    email: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
